<template>
  <div>
    <div></div>
    <b-button
      v-if="allAssignmentSummaryData.length > 0"
      @click="sendCommonManifestation(allAssignmentSummaryData)"
      size="sm"
      :variant="
        allAssignmentSummaryData[0].CountmainManifestationData == 0
          ? 'outline-danger'
          : 'outline-success'
      "
      >{{
        allAssignmentSummaryData[0].CountmainManifestationData == 0
          ? "Pending"
          : "Received"
      }}</b-button
    >
    <b-button
      :disabled="ItemAr.over_closedOverseas_status == 0 ? true : false"
      v-if="isOverseas"
      class="mb-1"
      @click="ItemAr != null ? commonOpenNoteModal(2, ItemAr) : ''"
      size="sm"
      :variant="
        ItemAr != null
          ? 'outline-primary'
          : allAssignmentSummaryData[0].debitcount >= 1
          ? 'outline-success'
          : 'outline-danger'
      "
      >Debit Note</b-button
    >
    <b-button
      :disabled="ItemAr.over_closedOverseas_status == 0 ? true : false"
      v-if="isOverseas"
      class="mb-1"
      @click="ItemAr != null ? commonOpenNoteModal(1, ItemAr) : ''"
      size="sm"
      :variant="
        ItemAr != null
          ? 'outline-primary'
          : allAssignmentSummaryData[0].creditcount >= 1
          ? 'outline-success'
          : 'outline-danger'
      "
      >Credit Note</b-button
    >
    <b-button
      v-if="!isOverseas"
      style="font-size: 0.475rem; margin-left: 2px"
      @click="AssignmentSummary()"
      size="sm"
      class="mt-1"
      variant="outline-info"
      >Check Manifestation</b-button
    >

    <!-- Added By Priyanshu SIngh Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="common-note-modal"
      hide-footer
      :title="
        noteModal.creditDebitNoteType == '1'
          ? 'CREDIT NOTE - ' + this.m_title
          : 'DEBIT NOTE - ' + this.m_title
      "
    >
      <div class="d-block text-center">
        <h4 class="error">
          {{
            noteModal.approvalStatus == "1"
              ? "Approved"
              : noteModal.sentForApproval == "1"
              ? "Sent for approval"
              : ""
          }}
        </h4>
      </div>
      <b-row>
        <b-col cols="11" style="text-align: end">
          <b-form-checkbox
            v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'"
            v-model="isValidationRequired"
            class="mr-3"
            style="display: inline-block; vertical-align: middle;"
          >
            Enable Validation
          </b-form-checkbox>
          <b-button
            v-if="noteModal.uploadCreditDebit != '' && noteModal.approvalStatus == '1'"
            @click="PrintNote(noteModal.uploadCreditDebit)"
            size="sm"
            variant="warning"
            >PDF</b-button
          >
          <b-button @click="addContent" size="sm">
            Add Particulars
            <i class="fa fa-plus-circle ml-1"></i>
          </b-button>
        </b-col>
        <b-col cols="12 text-center">
          <span v-if="noteModal.creditcount >= 1 && noteModal.creditDebitNoteType == '1'">
            <span class="error">Credit Note No. :</span>
            {{ noteModal.creditnoteSeriesDetailsCount }}
          </span>
          <span v-if="noteModal.debitcount >= 1 && noteModal.creditDebitNoteType == '2'">
            <span class="error">DEBIT Note No. :</span>
            {{ noteModal.debitnoteSeriesDetailsCount }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" class="mt-2">
          <label for="blType">Type <span class="error" v-if="isValidationRequired">*</span></label>

          <model-list-select
            :list="agentTypeList"
            option-value="TypeVal"
            option-text="TypeTxt"
            v-model="noteModal.agentType"
            placeholder="Select Type"
            @input="getAgentConsigneeList(noteModal.agentType)"
          ></model-list-select>
          <span class="error" v-if="!noteModal.agentType">{{
            errorCDNote.agentType
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="blType">
            To
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <!-- {{getAllAgentColoaderList}} -->
          <!-- :list="$store.getters['common/getAllAgentColoaderList']" -->
          <model-list-select
            :list="
              getAllAgentColoaderList.length > 0
                ? getAllAgentColoaderList
                : this.$store.getters['common/getAllAgentColoaderList']
            "
            option-value="agentName"
            option-text="agentName"
            v-model="noteModal.AgentColoader"
            :placeholder="
              noteModal.agentType == 'Consignee'
                ? 'Select Consignee'
                : 'Select Agent/Coloader'
            "
            @input="getConsigneeAgentDetails"
          ></model-list-select>
          <span class="error" v-if="!noteModal.AgentColoader">{{
            errorCDNote.AgentColoader
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Consignee'">
          <label for="Consignee Address">
            Consignee Address
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.agentconsigneeAddress"
            type="text"
            placeholder="Enter Consignee Address"
          ></b-form-input>
          <span class="error" v-if="!noteModal.agentconsigneeAddress">{{
            errorCDNote.agentconsigneeAddress
          }}</span>
        </b-col>
          <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Agent'">
          <label for="Agent Country">
            Agent Country
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.agent_country"
            type="text"
            placeholder="Enter Agent Country"
          ></b-form-input>
          <span class="error" v-if="!noteModal.agent_country">{{
            errorCDNote.agent_country
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Vessel/Voy">
            Vessel/Voy
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.vesselVoy"
            type="text"
            placeholder="Enter Vessel Voy"
          ></b-form-input>
          <span class="error" v-if="!noteModal.vesselVoy">{{
            errorCDNote.vesselVoy
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="HBL/AWB">
            HBL/AWB
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.house_bl_no"
            type="text"
            placeholder="Enter HBL/AWB"
          ></b-form-input>
          <span class="error" v-if="!noteModal.house_bl_no">{{
            errorCDNote.house_bl_no
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="MBL/MAWB">
            MBL/MAWB
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.master_bl_no"
            type="text"
            placeholder="Enter MBL/MAWB"
          ></b-form-input>
          <span class="error" v-if="!noteModal.master_bl_no">{{
            errorCDNote.master_bl_no
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SHIPPER">
            SHIPPER
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.clientName"
            type="text"
            placeholder="Enter SHIPPER"
          ></b-form-input>
          <span class="error" v-if="!noteModal.clientName">{{
            errorCDNote.clientName
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="CONSIGNEE">
            CONSIGNEE
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.consignee"
            type="text"
            placeholder="Enter CONSIGNEE"
          ></b-form-input>
          <span class="error" v-if="!noteModal.consignee">{{
            errorCDNote.consignee
          }}</span>
        </b-col>

        <b-col cols="4" class="mt-2">
          <label for="Destination">
            Destination
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.FPOD"
            type="text"
            placeholder="Enter Destination"
          ></b-form-input>
          <span class="error" v-if="!noteModal.FPOD">{{ errorCDNote.FPOD }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Container No">
            Container No.
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            disabled
            :formatter="capitalizeAll"
            v-model="noteModal.containerNoArryNote"
            type="text"
            placeholder="Enter Container No"
          ></b-form-input>
          <span class="error" v-if="!noteModal.containerNoArryNote">{{
            errorCDNote.containerNoArryNote
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Container Type">
            Container Type
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            disabled
            :formatter="capitalizeAll"
            v-model="noteModal.containersTypes"
            type="text"
            placeholder="Enter Container Type."
          ></b-form-input>
          <span class="error" v-if="!noteModal.containersTypes">{{
            errorCDNote.containersTypes
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SHIPPER INV.">
            SHIPPER INV.
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.ShipperInvDet"
            type="text"
            placeholder="Enter SHIPPER INV. Details"
          ></b-form-input>
          <span class="error" v-if="!noteModal.ShipperInvDet">{{
            errorCDNote.ShipperInvDet
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Booking No">
            Booking No
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.validBookingNo"
            type="text"
            placeholder="Enter Booking No"
          ></b-form-input>
          <span class="error" v-if="!noteModal.validBookingNo">{{
            errorCDNote.validBookingNo
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SOB">
            SOB
            <span class="error" v-if="isValidationRequired">*</span>
          </label>

          <date-picker
            :format="selectDateFormat"
            lang="en"
            id="SOB"
            :minute-step="1"
            name="SOB"
            v-model="noteModal.SOB"
          ></date-picker>
          <span class="error" v-if="!noteModal.SOB">{{ errorCDNote.SOB }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="ETADest">
            ETA Dest
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <date-picker
            :format="selectDateFormat"
            lang="en"
            id="ETADest"
            :minute-step="1"
            name="ETADest"
            v-model="noteModal.ETADest"
          ></date-picker>
          <span class="error" v-if="!noteModal.ETADest">{{ errorCDNote.ETADest }}</span>
        </b-col>

        <b-col cols="8">
          <label for="Remarks">Remarks</label>

          <b-form-textarea
            :formatter="capitalizeAll"
            v-model="noteModal.remarks"
            rows="3"
          ></b-form-textarea>
        </b-col>
        <b-col cols="12">
          <table class="table table-sm table-bordered mt-2">
            <tbody style="background: white">
              <tr v-if="noteParticulars.length > 0">
                <th scope="col" style="width: 5px">SN.</th>
                <th scope="col" style="width: 600px">Particulars</th>
                 <th scope="col" style="width: 600px">QTY</th>
                <th scope="col" style="width: 180px">Amount</th>
                <th scope="col" style="width: 180px">Final</th>
                <th scope="col" style="width: 180px">Selected Cont</th>
                <th scope="col" style="width: 180px">Currency</th>
                <th scope="col" style="width: 5px">Actions</th>
              </tr>
              <tr v-for="(item, index) in noteParticulars" :key="index">
                <th scope="row">{{ index + 1 }}.</th>
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.parti"
                    placeholder="Enter Particular"
                  ></b-form-input>
                  <span class="error" v-if="item.parti_err">{{ item.parti_err }}</span>
                </td>
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.qty"
                    placeholder="Enter Quantity"
                    @input="TotalAMT"
                  ></b-form-input>
                  <span class="error" v-if="item.qty_err">{{ item.qty_err }}</span>
                </td>
                   <!-- <td>{{ item.qty }}</td> -->
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.amt"
                    type="number"
                    placeholder="Enter Amount"
                    v-on:keyup="TotalAMT"
                  ></b-form-input>
                  <span class="error" v-if="item.amt_err">{{ item.amt_err }}</span>
                </td>
                <td>{{ item.final_amt }}</td>
                <td>{{ item.container_selected }}</td>
                <td>
                  <model-list-select
                    :list="$store.getters['common/getAllCurrencyList']"
                    v-model="item.currency"
                    option-value="currency_id"
                    option-text="currencyCode"
                    placeholder="Select Currency"
                  ></model-list-select>
                  <span class="error" v-if="item.currency_err">{{
                    item.currency_err
                  }}</span>
                </td>
                <td>
                  <b-button size="sm" @click="removeParti(index)">
                  <!-- <b-button v-if="index > 0" size="sm" @click="removeParti(index)"> -->
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                  </b-button>
                </td>
              </tr>
              <tr v-if="TotAMT != 0">
                <td colspan="2">
                  <b style="color: blue; font-weight: bold; font-size: 18px">Total</b>
                </td>
                <td colspan="3">
                  <b style="color: blue; font-weight: bold; font-size: 18px">{{
                    TotAMT
                  }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col cols="12" class="text-center">
          <b-button
            :disabled="IsCDNotedisabled"
            class="mt-3"
            variant="success"
            v-if="noteParticulars.length > 0 && noteModal.AgentColoader"
            @click="submitNote"
          >
            <span v-if="IsCDNotedisabled">
              <b-spinner small class="mr-1"></b-spinner>Sending...
            </span>
            <span v-else>Send for approval</span>
          </b-button>
          <b-button class="mt-3" variant="outline-danger" @click="hideNoteModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- Added By Priyanshu SIngh End -->
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>

    <!-- Assignment Summary Modal End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    moduleType: {
      type: String,
      default: "",
    },
    cr_ass_date: {
      type: String,
      default: "",
    },
    cr_all_module_id: {
      type: String,
      default: "",
    },
    cr_jb_series: {
      type: String,
      default: "",
    },
    transportType: {
      type: String,
      default: "",
    },
    Jobtype: {
      type: String,
      default: "",
    },
    commonId: {
      type: String,
      default: "",
    },
    shipmentType: {
      type: String,
      default: "",
    },
    isOverseas: {
      type: Boolean,
      default: "",
    },
    ItemAr: {
      type: Object,
      default: "",
    },
  },
  // props: [
  //   "title",
  //   "moduleType",
  //   "cr_ass_date",
  //   "cr_all_module_id",
  //   "cr_jb_series",
  //   "transportType",
  //   "Jobtype",
  //   "commonId",
  //   "shipmentType",
  //   "isOverseas",
  //   "ItemAr",
  // ],
  beforeMount() {
    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllConsigneeList",
      JSON.stringify({
        itemCode: "ConsigneeList",
      })
    );
    // Removed automatic getAssignmentSummary() call - it should only be called when button is clicked
  },

  data() {
    return {
      allAssignmentSummaryData: [],
      all_module_id: this.cr_all_module_id,
      m_title: this.title,
      m_moduleType: this.moduleType,
      ass_date: this.cr_ass_date,
      jb_series: this.cr_jb_series,
      m_transportType: this.transportType,
      m_Jobtype: this.Jobtype,
      m_commonId: this.commonId,
      m_shipmentType: this.shipmentType,
      Filter_Flag: false,
      TotAMT: 0,
      ManifestationParticulars: [],
      IsCDNotedisabled: false,
      NoteData: "",
      isValidationRequired: true,
      errorCDNote: {
        agentType: "",
        AgentColoader: "",
        vesselVoy: "",
        house_bl_no: "",
        master_bl_no: "",
        clientName: "",
        consignee: "",
        FPOD: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: "",

        validBookingNo: "",
        SOB: "",
        ETADest: "",
      },
      arrayErrorCDNote: [
        {
          agentType: "Please Select Type",
          AgentColoader: "Please Select To",
          vesselVoy: "Please Enter Vessel/Voy ",
          house_bl_no: "Please Enter HBL/AWB",
          master_bl_no: "Please Enter MBL/MAWB",
          clientName: "Please ENter SHIPPER",
          consignee: "Please Enter Consignee",
          FPOD: "Please Enter FPOD",
          containerNoArryNote: "Please Enter Container No.",
          containersTypes: "Please Enter Container Type",
          ShipperInvDet: "Please Enter SHIPPER INV",
          validBookingNo: "Please Enter Booking No",
          SOB: "Please Enter SOB",
          ETADest: "Please Enter ETA Destination",
        },
      ],
      selectDateFormat,
      allModuleId: "",
      ShowSendApproval: "",
      AgentColoaderList: [],
      noteParticulars: [],
      CurrencyList: [],
      containerTypeDetailFactory: [],
      note_id: "",
      getCLientData: ["gfdg"],
      getAllAgentColoaderList: [],
      agentTypeList: [
        {
          TypeVal: "Consignee",
          TypeTxt: "Consignee",
        },
        {
          TypeVal: "Agent",
          TypeTxt: "Agent",
        },
      ],
      noteModal: {
        agentType: "Agent",
        fk_agent_id: "",
        fk_consignee_id: "",
        agent_country:"",
        agentconsigneeAddress: "",

        shipper: "",
        branchName: "",
        branchList: [],
        AgentColoader: "",
        creditDebitNoteType: "",
        remarks: "",
        noteDate: "",
        note_id: "",
        noteContent: "",
        noteAmount: "",
        noteCurrency: "",
        ffExportFclId: "",
        allModuleId: "",
        fclBlId: "",
        BLNumber: "",
        uploadCreditDebit: "",
        sentForApproval: "",
        approvalStatus: "",
        masterorLinerBlNo: "",
        type: "",
        commonId: this.m_commonId,
        validBookingNo: "",
        SOB: "",
        ETADest: "",
      },
      docURL: URL_BASE_DOC,
      validate: false,
      isSubmittingNote: false,
      alert: {
        content: "Alert Message",
        ok: "OK",
      },
      //Added By Priyanshu SIngh End
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
    isValidationRequired(newVal) {
      if (!newVal) {
        // Clear all validation errors when validation is disabled
        this.errorCDNote = {
          agentType: "",
          AgentColoader: "",
          vesselVoy: "",
          house_bl_no: "",
          master_bl_no: "",
          clientName: "",
          consignee: "",
          FPOD: "",
          containerNoArryNote: "",
          containersTypes: "",
          ShipperInvDet: "",
          validBookingNo: "",
          SOB: "",
          ETADest: "",
        };
        this.noteParticulars.forEach((item) => {
          item.parti_err = "";
          item.qty_err = "";
          item.amt_err = "";
          item.currency_err = "";
        });
      }
    },
  },
  methods: {
    sendCommonManifestation(item) {
      console.log('sendManifest_ffFclallModuleId all_module_id=>',item,this.all_module_id);
      console.log('sendManifest_ffExportFclId m_commonId=>',this.m_commonId);
      console.log('sendManifest_ffFclallModuleId m_shipmentType=>',this.m_shipmentType);
      console.log('sendManifest_shipmentType m_moduleType=>',this.m_moduleType);
      console.log('sendManifest_JobSeries jb_series=>',this.jb_series);
      console.log('sendManifest_JOBSERIES jb_series=>',this.jb_series);
      console.log('sendManifest_Transport_Type jb_series=>',this.m_transportType);
      console.log('sendManifest_Jobtype jb_series=>',this.m_Jobtype);
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffExportFclId", "");
      this.$sessionsStorage.set("sendManifest_shipmentType", "");
      this.$sessionsStorage.set("sendManifest_moduleType", "");
      this.$sessionsStorage.set("sendManifest_JobSeries", "");
      this.$sessionsStorage.set("sendManifest_JOBSERIES", "");
      this.$sessionsStorage.set("sendManifest_Transport_Type", "");
      this.$sessionsStorage.set("sendManifest_Jobtype", "");
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", this.all_module_id);
      this.$sessionsStorage.set("sendManifest_ffExportFclId", this.m_commonId);
      this.$sessionsStorage.set("sendManifest_shipmentType", this.m_shipmentType);
      this.$sessionsStorage.set("sendManifest_moduleType", this.m_moduleType);
      this.$sessionsStorage.set("sendManifest_JobSeries", this.jb_series);
      this.$sessionsStorage.set("sendManifest_JOBSERIES", this.jb_series);
      this.$sessionsStorage.set("sendManifest_Transport_Type", this.m_transportType);
      this.$sessionsStorage.set("sendManifest_Jobtype", this.m_Jobtype);
      this.$router.push({
        path: "/freightForwarding/CommonManifestation",
      });
    },
    AssignmentSummary() {
      this.Filter_Flag = true;
      this.getAssignmentSummary();
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      );
      this.$store.dispatch(
        "common/setAllLedgerList",
        JSON.stringify({
          itemCode: "LedgerList",
        })
      );
      this.$store.dispatch("common/setAllAgentColoaderList");
    },
    removeTags(str) {
      if (str === null || str === "") return false;
      else str = str.toString();
      return str.replace(/(<([^>]+)>)/gi, "");
    },
    validateAddManifestationDetail() {
      let validate_new = true;
      let MainARR = this.noteParticulars;
      for (let j = 0; j < MainARR.length; j++) {
        const row = this.noteParticulars[j];
        const qtyNum = Number(row.qty);
        const amtNum = Number(row.amt);
        const finalAmt = qtyNum * amtNum;
        row.parti_err = !row.parti || !String(row.parti).trim() ? "Please Enter Particular" : "";
        row.qty_err =
          row.qty === "" || row.qty === null || row.qty === undefined || qtyNum <= 0
            ? "Please Enter Quantity"
            : "";
        row.amt_err =
          row.amt === "" || row.amt === null || row.amt === undefined || amtNum <= 0
            ? "Please Enter Amount"
            : "";
        if (!row.qty_err && !row.amt_err && finalAmt <= 0) {
          row.amt_err = "Final Amount must be greater than 0";
        }
        row.currency_err = !row.currency ? "Please Enter Currency" : "";

        if (row.parti_err || row.qty_err || row.amt_err || row.currency_err) {
          validate_new = false;
        }
      }
      console.log("this.noteParticulars=>", this.noteParticulars);
      this.validate = validate_new;
    },
    getAgentConsigneeList(agentType) {
      this.noteModal.AgentColoader = "";
      if (agentType == "Agent") {
        this.getAllAgentColoaderList = this.$store.getters[
          "common/getAllAgentColoaderList"
        ];
      } else if (agentType == "Consignee") {
        this.getAllAgentColoaderList = this.$store.getters["common/getAllConsigneeList"];
      }
      this.noteModal.AgentColoader = "";
      console.log("AgentColoader Details=>", this.noteModal.AgentColoader);
    },
    getConsigneeAgentDetails() {
      this.noteModal.fk_consignee_id = "";
      this.noteModal.fk_agent_id = "";
      this.noteModal.agent_country = "";
      this.noteModal.agentconsigneeAddress = "";
      if (this.noteModal.agentType == "Consignee") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.noteModal.AgentColoader) {
            console.log("Consignee Details=>", val);
            this.noteModal.fk_consignee_id = val.agntColoaderId;
            this.noteModal.agentconsigneeAddress = val.address;
            this.noteModal.agentAddress = val.address;
          }
        });
      } else if (this.noteModal.agentType == "Agent") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.noteModal.AgentColoader) {
            console.log("Agent Details=>", val);
            this.noteModal.fk_agent_id = val.agntColoaderId;
            this.noteModal.agentconsigneeAddress = val.address;
            this.noteModal.agentAddress = val.address;
            this.noteModal.agent_country=val.countryName;
          }
        });
      }
    },
    submitNote() {
      if (this.isSubmittingNote) return false;
      if (this.isValidationRequired) {
        this.validateCDNote();
        if (this.validate == false) return false;
        this.validateAddManifestationDetail();
        if (this.validate == false) return false;
      }else{
        this.validate=true;
      }

      this.isLoading = true;
      this.isSubmittingNote = true;
      this.ShowSendApproval = false;

      if (this.noteParticulars.length <= 0) {
        this.isSubmittingNote = false;
        this.alert.content = "Please add particulars";
        this.$refs["addPop"].open();
        return false;
      }

      let noteParti = [];
      let noteAmt = [];
      let noteCurrency = [];
      this.noteModal["fk_currency_id"] = "";
      for (let i = 0; i < this.noteParticulars.length; i++) {
        noteParti.push(this.noteParticulars[i].parti);
        const finalAmount = Number(this.noteParticulars[i].final_amt);
        noteAmt.push(Number.isFinite(finalAmount) ? finalAmount : 0);
        noteCurrency.push(
          this.noteParticulars[i].currency ? this.noteParticulars[i].currency : 0
        );
        this.noteModal["fk_currency_id"] = this.noteParticulars[i].currency
          ? this.noteParticulars[i].currency
          : "1";
      }
      this.noteModal.noteContent = noteParti.toString();
      this.noteModal.noteAmount = noteAmt.toString();
      this.noteModal.noteCurrency = noteCurrency.toString();

      // console.log("NoteData=>",this.NoteData);
      // console.log("noteModal=>",this.noteModal);
      this.noteModal["containerNoArryNote"] = this.noteModal.containerNoArryNote;
      this.noteModal["containerTypesArr"] = this.noteModal.containersTypes;
      this.noteModal["ShipperInvDet"] =
      this.noteModal.ShipperInvDet == undefined ? "" : this.noteModal.ShipperInvDet;
      this.noteModal["type"] = this.NoteData.over_type || (this.NoteData.mainSalesSeries.split("/")[0]+" "+this.NoteData.transportType);
      this.noteModal["noteParticulars"] = this.noteParticulars;
      this.noteModal["allModuleId"] = this.NoteData.allModuleId;
      this.noteModal["agentName"] = this.noteModal.AgentColoader;
      this.noteModal["overseas_agent"] = this.noteModal.AgentColoader;
      this.noteModal["agentAddress"] = this.NoteData.agentAddress;
      this.noteModal["vesselVoy"] = this.noteModal.vesselVoy;
      this.noteModal["shipper"] =
        this.noteModal.clientName == undefined ? "" : this.noteModal.clientName;
      this.noteModal["consignee"] =
        this.noteModal.consignee == undefined ? "" : this.noteModal.consignee;
      this.noteModal["fclBlId"] = 0;
      this.noteModal["branchName"] = this.NoteData.raisedFrom;
      this.noteModal["FinalPlace"] = this.NoteData.FPOD
        ? this.NoteData.FPOD
        : this.noteModal.FPOD;

      this.noteModal["master_bl_no"] =
        this.noteModal.master_bl_no == undefined ? "" : this.noteModal.master_bl_no;
      this.noteModal["house_bl_no"] =
        this.noteModal.house_bl_no == undefined ? "" : this.noteModal.house_bl_no;
      this.noteModal["masterorLinerBlNo"] =
        this.noteModal.master_bl_no == undefined ? "" : this.noteModal.master_bl_no;
      this.noteModal["BLNumber"] =
        this.noteModal.house_bl_no == undefined ? "" : this.noteModal.house_bl_no;
      this.noteModal["page"] = "common";
      this.noteModal["salesSeries"] = this.NoteData.mainSalesSeries;
      this.noteModal["salesSeriesUpload"] = this.NoteData.mainSalesSeries.replaceAll(
        "/",
        "_"
      );
      // alert(this.NoteData.over_common_id)
      // alert(this.noteModal.commonId)
      this.noteModal["ffExportFclId"] =
        this.NoteData.over_commonId == undefined
          ? this.noteModal.commonId
          : this.NoteData.over_common_id ||"0";
      this.noteModal["LPM"] = this.NoteData.POL;
      this.noteModal["PODM"] = this.NoteData.POD;
      this.noteModal["PORM"] = this.NoteData.POR;
      this.noteModal["clientNameM"] = this.NoteData.clientName;
      this.noteModal["shippingLineM"] = this.NoteData.shippingLine;
      this.noteModal["ASeriesM"] = this.NoteData.mainSalesSeries;
      this.noteModal["agentNameM"] = this.noteModal.AgentColoader;
      this.noteModal["overseas_agentM"] = this.noteModal.AgentColoader;
      this.noteModal["ASDateM"] = this.NoteData.assDate;
      this.noteModal["ToM"] = this.noteModal.AgentColoader;
      if (this.noteModal["vesselVoy"] == undefined) {
        this.noteModal["vesselVoy"] = "";
      }

      if (this.noteModal["fclBlId"] == undefined) {
        this.noteModal["fclBlId"] = "0";
      }

      if (this.noteModal["agentAddress"] == undefined) {
        this.noteModal["agentAddress"] = "";
      }

      if (this.noteModal["BLNumber"] == "NaN") {
        this.noteModal["BLNumber"] = "";
      }

      this.noteModal["validBookingNo"] = this.NoteData.validBookingNo
        ? this.NoteData.validBookingNo
        : this.noteModal.validBookingNo;
      this.noteModal["SOB"] = this.NoteData.SOB ? this.NoteData.SOB : this.noteModal.SOB;
      this.noteModal["ETADest"] = this.NoteData.ETADest
        ? this.NoteData.ETADest
        : this.noteModal.ETADest;
      this.IsCDNotedisabled = true;
      console.log("this.NoteData JIO=>", this.NoteData);
      console.log("this.noteModal JIO=>", this.noteModal);
      // return false;
      if (this.validate != false) {
        console.log(this.noteModal);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addCreditDebitNoteNew_VP.php`,
          data: JSON.stringify(this.noteModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // Always close immediately on successful API response.
              this.$refs["common-note-modal"].hide();

              if (data.msg) {
                if (this.alert) this.alert.content = data.msg;
              } else {
                if (this.alert) this.alert.content = data.msg;
              }
              this.IsCDNotedisabled = false;

              Object.keys(this.noteModal).map((x) => {
                this.noteModal[x] = "";
              });
              this.noteParticulars = [];
              if (this.$refs["addPop"]) this.$refs["addPop"].open();
              // this.getData();
              this.viewFFExportFCL("0", "0", "1", "1");
            }
          })
          .catch((error) => {})
          .finally(() => {
            this.isSubmittingNote = false;
            this.IsCDNotedisabled = false;
            this.isLoading = false;
          });
      }
    },
    TotalAMT() {
      let TotAmount = 0;
      this.noteParticulars.forEach((value, index) => {
        let amount = 0;
        if (isNaN(value.amt) || value.amt == "") {
          amount = 0;
        } else {
          amount = value.amt*value.qty;
          // amount = value.amt;
        }
        value.final_amt=value.amt*value.qty;
        if (this.TotAMT == 0) {
          TotAmount = eval(amount);
        } else {
          TotAmount = eval(TotAmount) + eval(amount);
        }
        this.TotAMT = TotAmount;
      });
      console.log("this.totFinalAmount item=>", this.TotAMT);
      this.$forceUpdate();
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.CurrencyList = [];
        let payload = {
          Currency: "Currency_DropDown",
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/viewAllCurrencyList.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.CurrencyList.length > 0) {
                this.CurrencyList = data.CurrencyList;
              } else {
                this.CurrencyList = [];
              }
              return resolve(this.CurrencyList);
            }
          })
          .catch((error) => {});
      });
    },
    commonOpenNoteModal(id, item) {
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      );
      this.$store.dispatch(
        "common/setAllLedgerList",
        JSON.stringify({
          itemCode: "LedgerList",
        })
      );
      this.TotAMT = 0;
      this.noteParticulars = [];
      let noteType = "";
      if (id == "1") {
        noteType = "CREDIT";
      } else if (id == "2") {
        noteType = "DEBIT";
      }
      item.mainManifestationData.forEach((element) => {
        if (noteType == element.noteType) {
          let obj = {
            parti: element.ledgerId,
            amt: element.amount,
            currency: element.currency,
            qty: element.qty,
            container_selected: element.container_selected,
            final_amt: element.qty*element.amount
          };
          this.noteParticulars.push(obj);
        }
      });
      if (this.noteParticulars.length > 0) {
        this.TotalAMT();
      }
      this.NoteData = "";
      this.containerTypeDetailFactory = [];
      this.NoteData = item;
      console.log("Priyanshu SIngh=>", item);
      this.noteModal.containersTypes =
        item.over_shipmentType == "Sea" ? item.containerType : "NA";
      this.noteModal.containerNoArryNote =
        item.over_shipmentType == "Sea" ? item.containerNo : "NA";
      this.noteModal.FPOD = item.over_shipmentType == "Sea" ? item.FPOD : item.airDesti;
      this.noteModal.house_bl_no = item.house_bl_no || item.HBLNO;
      this.noteModal.master_bl_no = item.master_bl_no || item.MBLNO;
      this.noteModal.vesselVoy = item.vesselVoy || item.leg1_vessel;
      this.noteModal.clientName = item.clientName;
      // alert(item.mainManifestationData[0].agent_coloder_txt);
      this.noteModal.AgentColoader = item.agent_coloder_txt;
      this.noteModal.shipper = item.clientName;
      this.noteModal.creditcount = item.creditcount;
      this.noteModal.debitcount = item.debitcount;
      this.noteModal.commonId = item.over_common_id;
      this.noteModal.SOB = item.sob_date_detected;
      this.noteModal.ETADest = item.ETADest;
      this.noteModal.validBookingNo = item.validBookingNo;
      let creditnoteSeriesDetails = [];
      let debitnoteSeriesDetails = [];
      if (item.NoteDetails.length > 0) {
        item.NoteDetails.map((NS) => {
          if (NS.creditDebitNoteType == 1) creditnoteSeriesDetails.push(NS.noteSeries);
        });
        item.NoteDetails.map((NS) => {
          if (NS.creditDebitNoteType == 2) debitnoteSeriesDetails.push(NS.noteSeries);
        });
      }
      this.noteModal.creditnoteSeriesDetailsCount = creditnoteSeriesDetails.toString();
      this.noteModal.debitnoteSeriesDetailsCount = debitnoteSeriesDetails.toString();
      console.log("Single Note Details=>", item);
      console.log("this.NoteData=>", this.NoteData);
      // return false;

      this.noteModal.creditDebitNoteType = id;
      this.$refs["common-note-modal"].show();
    },
    hideNoteModal() {
      this.noteModal.approvalStatus = "";
      this.noteModal.sentForApproval = "";
      this.noteContent = "";
      this.noteAmount = "";
      this.noteCurrency = "";
      this.note_id = "";
      this.noteModal.remarks = "";
      this.noteParticulars = [];
      this.TotAMT = 0;
      this.$refs["common-note-modal"].hide();
      this.isLoading = false;
    },

    addContent() {
      let obj = {
        parti: "",
        amt: "",
        currency: "1",
        qty:1,
        container_selected:1,
        final_amt:0,
        parti_err: "",
        qty_err: "",
        amt_err: "",
        currency_err: "",
      };
      this.noteParticulars.push(obj);
    },
    removeParti(index) {
      this.noteParticulars.splice(index, 1);
      if (this.noteParticulars.length === 0) {
        this.TotAMT = 0;
      }
      this.TotalAMT();
    },
    TotalAMT() {
      if (!this.noteParticulars.length) {
        this.TotAMT = 0;
        this.$forceUpdate();
        return;
      }
      let TotAmount = 0;
      this.noteParticulars.forEach((value, index) => {
        let amount = 0;
        if (value.qty <= 0) {
          value.qty = 1;
        }
        if (isNaN(value.amt) || value.amt == "") {
          amount = 0;
        } else {
          amount = value.amt * value.qty;
        }
        value.final_amt = Number(value.amt) * Number(value.qty);
        TotAmount = Number(TotAmount) + Number(amount);
      });
      this.TotAMT = Number(TotAmount.toFixed(2));
      console.log("this.totFinalAmount item=>", this.TotAMT);
      this.$forceUpdate();
    },
    validateCDNote() {
      if (!this.isValidationRequired) {
        this.validate = true;
        return;
      }
      let validate_new = true;
      Object.keys(this.errorCDNote).map((x, index) => {
        if (
          this.noteModal[x] == "" ||
          this.noteModal[x] == undefined ||
          this.noteModal[x] == null
        ) {
          this.errorCDNote[x] = this.arrayErrorCDNote[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    PrintNote(ffExportFclSeries, uploadCreditDebit) {
      window.open(
        `${this.docURL}/ASSIGNMENT_UPLOADS/` +
          ffExportFclSeries.replaceAll("/", "_") +
          "/" +
          uploadCreditDebit
      );
    },
    getAssignmentSummary() {
      // alert(this.Filter_Flag)
      if (this.Filter_Flag == true) {
        let AssignmentSummary = {
          filter: "CRDRDetails",
          allModuleId: this.cr_all_module_id,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/viewAssignmentTrackDetails.php`,
          data: JSON.stringify(AssignmentSummary),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.CreditDebitNoteDetails.length > 0) {
                this.allAssignmentSummaryData = data.CreditDebitNoteDetails;
              }
              // this.isLoading = false;
              this.JqueryFun();
            }
          })
          .catch((error) => {});
      }
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// overseasCRDRNote.vue?eb04807c